import React from 'react';
import SearchMedicamentRecordListItemMedicament, {
	SearchMedicamentRecordListItemMedicamentScheme,
} from './SearchMedicamentRecordListItemMedicament';
// @ts-ignore
import styles from './SearchMedicamentRecordListItem.module.scss';

export interface SearchMedicamentRecordListItemScheme {
	title: string;
	children: SearchMedicamentRecordListItemMedicamentScheme[];
}

interface Props {
	item: SearchMedicamentRecordListItemScheme;
}

const SearchMedicamentRecordListItem: React.FC<Props> = ({ item }) => {
	return (
		<>
			<div className={styles.title}>{item.title}</div>
			{item.children.map(item => (
				<SearchMedicamentRecordListItemMedicament item={item} />
			))}
		</>
	);
};

export default SearchMedicamentRecordListItem;
